import { deletePost } from 'src/client/publication'
import useMutation from '../useMutation/useMutation'

const useDeletePost = () => useMutation((postId: number) => deletePost(postId))

export default useDeletePost
